export default __webpack_public_path__ + "static/media/img-gt-mode-off-bg.eea92390.jpg";